import styled from '../../../../../utils/styling/styled';

import GlobalDistributionPin from '../../GlobalDistributionItems/GlobalDistributionPin';

export const Pin = styled(GlobalDistributionPin)`
  left: 56%;
  top: 27%;
`;
